import Request from '@activity/request'
import { getToken, logout } from './utils'
import { $alert, isObject, toast } from '@/utils'
import { $t } from '@/i18n/LocalContext'
import { NativeRequest } from 'onemt-sdk-native'
import appExpose from '@app/expose'

const { config } = appExpose

let $request: Request | null = null

export const createRequest = (
  userInfo: UserInfo,
  sdkConfig: SdkConfig,
  gamePlayer: GamePlayer
) => {
  const inSDK = window.inSDK

  let requestExternalOptions: {
    serverId?: string
    playerId?: string
    uid?: string
    sessionId?: string
    userid?: string
    lang?: string
    platform?: string
    deviceid?: string
    token?: string
  } = {}

  if (!inSDK) {
    requestExternalOptions.token = getToken()
    requestExternalOptions.playerId = userInfo.playerId
  } else {
    requestExternalOptions.serverId = gamePlayer.serverId
    requestExternalOptions.uid = gamePlayer.playerId
    requestExternalOptions.sessionId = userInfo.sessionId
    requestExternalOptions.userid = userInfo.userId
    requestExternalOptions.lang = userInfo.lang
  }
  requestExternalOptions.platform = sdkConfig.platform || 'web'
  requestExternalOptions.deviceid = sdkConfig.deviceId

  $request = new Request(
    Object.assign(
      {
        domain: `https://${
          process.env.ENV !== 'production' ? 'testh5api' : 'h5api'
        }.onemt.co`,
        // domain: 'http://10.0.0.199:18013',
        appid: window.appId,
        lang: window.lang,
        serverErrorCatch(data: Rsp<unknown>) {
          const codeList = [
            'NETWORK_ERROR',
            'ERR_LEVEL_NOT_MEET',
            'ERR_ALREADY_BOUND_USER',
            '',
            ...config?.exceptionCode,
          ] as const
          const rtnmsg = data.rtnmsg as (typeof codeList)[number]
          const code: typeof rtnmsg = codeList.includes(rtnmsg)
            ? rtnmsg
            : codeList[0]
          if (code === codeList[1]) {
            // $alert($t(code), {
            //   rejectText: $t('退出登录'),
            //   onReject() {
            //     logout()
            //   },
            // })
            toast($t(code), true)
          } else {
            $alert($t(code))
          }
        },
        httpErrorCatch(error: any) {
          let response
          if (_isObject(error)) {
            response = error.response
          }
          if (isObject(response) && response != null && response.config) {
            const status = response.status
            const requestConfig = (response.config || {}) as {
              url?: string
              baseURL?: string
            }
            requestConfig.url = requestConfig.url || ''
            requestConfig.baseURL = requestConfig.baseURL || ''
            const route = requestConfig.url.slice(
              `${requestConfig.baseURL}/event/${config.serverName}`.length
            )
            if (route !== '/show/isbind' && status === 401) {
              if (!inSDK) {
                logout('token过期请重新登录', true, true)
              } else {
                NativeRequest('closePage')
              }
            }
          }

          function _isObject(obj: unknown) {
            return (
              Object.prototype.toString.call(obj) === '[object Error]' ||
              isObject(obj)
            )
          }
        },
      },
      requestExternalOptions
    )
  )
}

export default (() => $request) as () => Request
